import type { Transaction } from '@debtbot/shared';
import { useT } from '../i18n';
import { formatDateTime, txDelta, txEmoji, txTitle } from '../lib/format';
import { Amount } from './Amount';

export function TransactionRow({
  tx,
  meId,
  onClick,
}: {
  tx: Transaction;
  meId: string;
  onClick: () => void;
}) {
  const t = useT();
  const pending = tx.id.startsWith('pending-');
  const disputed = tx.status === 'DISPUTED';
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={pending}
      data-testid="transaction-row"
      className={`flex w-full items-center justify-between gap-3 py-3 text-left active:opacity-70 ${pending ? 'opacity-60' : ''}`}
    >
      <div className="flex min-w-0 items-center gap-3">
        <span className="text-xl">{txEmoji(tx)}</span>
        <div className="min-w-0">
          <div className="truncate">{txTitle(tx)}</div>
          <div className="truncate text-xs text-hint">
            {formatDateTime(tx.occurred_at)}
            {disputed && (
              <>
                {' · '}
                <span className="text-warning">⚠ {t.tx.disputed}</span>
              </>
            )}
            {tx.is_edited && ` · ${t.tx.edited}`}
          </div>
        </div>
      </div>
      <Amount
        money={txDelta(tx, meId)}
        className={`shrink-0 font-semibold ${disputed ? 'line-through opacity-70' : ''}`}
      />
    </button>
  );
}
